(function () {
  'use strict';

  /**
   * @typedef {import('./types').WepsterConfigResponse} WepsterConfigResponse
   */

  angular
    .module('settings.wepster')
    .factory('WepsterSettings', WepsterSettings);

  WepsterSettings.$inject = ['$resource'];

  /**
   * @param {angular.resource.IResourceService} $resource
   */
  function WepsterSettings($resource) {
    const transformResponse = (json) => {
      /** @type {WepsterConfigResponse} */
      const data = JSON.parse(json);

      if (!data.success) {
        throw new Error(`Expected successful response: ${data}`);
      }

      return data.wepster_config;
    };

    return $resource(
      '/api/wepster/config',
      {},
      {
        get: {
          method: 'GET',
          transformResponse,
        },
        getCached: {
          method: 'GET',
          transformResponse,
          cache: true,
        },
        save: {
          method: 'POST',
          transformResponse,
        },
        addContact: {
          url: 'https://my.wepster.com/api/v1/contact/add',
          method: 'POST',
          withCredentials: false,
        },
      },
    );
  }
})();
